import apiV2 from '../api/v2';

// Mirrors backend/src/routes/api/v2/patients/workflow/design/final-review.validator.ts.
export type FinalReviewSection = 'design' | 'dx';
export type HandBackTarget = 'design' | 'dx' | 'both';
export type HandBackSource = 'final-review' | 'orthodontist';

export interface FinalReviewNote {
    section: FinalReviewSection;
    text: string;
}

export interface ActiveHandBack {
    eventId: string;
    source: HandBackSource;
    target: HandBackTarget;
    // Older hand-backs stored Dx section ids (e.g. 'risks') instead of 'dx'.
    notes: Array<{ section: string; text: string }>;
    at: string;
    by: string;
    byName?: string;
}

// The latest Final review or orthodontist hand-back, null once the case is past it.
export async function fetchActiveHandBack(patientId: string): Promise<ActiveHandBack | null> {
    const response = await apiV2.get<{ success: boolean; data: ActiveHandBack | null }>(
        `/patients/${patientId}/workflow/design/final-review/hand-back`
    );
    return response.data.data;
}
